import { DisciplineResults } from '../../Components/DisciplineResults';

export const BowlingPinMatchResults = () => {
  return (
    <DisciplineResults 
      discipline="BOWLING_PIN_MATCH" 
      disciplineName="Bowling Pin Match"
    />
  );
};
